module.exports = __webpack_public_path__ + "img/Grupo 1584@2x.2d2018c6.png";